module.exports = __webpack_public_path__ + "staticV3/img/7c562bf0.empty-coupon.png";